var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PrimaryButton',{attrs:{"icon":"arrow-right"},on:{"click":function($event){return _vm.$router.push({ name: 'subscribe' })}}},[_vm._v("Comece agora mesmo")])}
var staticRenderFns = []

export { render, staticRenderFns }